var blockBundles;

try {
    blockBundles = {
		pubgm_mainsite: {
			header:{
				header: {
					 html: require("../../pubgm_mainsite/header/header.html.twig"), 
					 scss: require("../../pubgm_mainsite/header/header.scss"), 
					 js: require("../../pubgm_mainsite/header/header.js"), 
					 dir: "pubgm_mainsite/header/header"
				}
			},
			content:{
				event_list: {
					 html: require("../../pubgm_mainsite/event_list/event_list.html.twig"), 
					 scss: require("../../pubgm_mainsite/event_list/event_list.scss"), 
					 js: require("../../pubgm_mainsite/event_list/event_list.js"), 
					 dir: "pubgm_mainsite/event_list/event_list"
				},
				event_list: {
					html: require("../../pubgm_mainsite/news_list/news_list.html.twig"), 
					scss: require("../../pubgm_mainsite/news_list/news_list.scss"), 
					js: require("../../pubgm_mainsite/news_list/news_list.js"), 
					dir: "pubgm_mainsite/news_list/news_list"
			   },
				
				error: {
					 html: require("../../pubgm_mainsite/error/error.html.twig"),
					 scss: require("../../pubgm_mainsite/error/error.scss"),
					 js: require("../../pubgm_mainsite/error/error.js"),
					 dir: "pubgm_mainsite/error/error"
				},
				main_sub_news_details: {
					 html: require("../../pubgm_mainsite/main_sub_news_details/main_sub_news_details.html.twig"),
					 scss: require("../../pubgm_mainsite/main_sub_news_details/main_sub_news_details.scss"),
					 js: require("../../pubgm_mainsite/main_sub_news_details/main_sub_news_details.js"),
					 dir: "pubgm_mainsite/main_sub_news_details/main_sub_news_details"
				},
				main_sub_event_details: {
					 html: require("../../pubgm_mainsite/main_sub_event_details/main_sub_event_details.html.twig"),
					 scss: require("../../pubgm_mainsite/main_sub_event_details/main_sub_event_details.scss"),
					 js: require("../../pubgm_mainsite/main_sub_event_details/main_sub_event_details.js"),
					 dir: "pubgm_mainsite/main_sub_event_details/main_sub_event_details"
				},
				introduce: {
					 html: require("../../pubgm_mainsite/introduce/introduce.html.twig"), 
					 scss: require("../../pubgm_mainsite/introduce/introduce.scss"), 
					 js: require("../../pubgm_mainsite/introduce/introduce.js"), 
					 dir: "pubgm_mainsite/introduce/introduce"
				},
				wiki_home: {
					html: require("../../pubgm_mainsite/wiki_home/wiki_home.html.twig"), 
					scss: require("../../pubgm_mainsite/wiki_home/wiki_home.scss"), 
					js: require("../../pubgm_mainsite/wiki_home/wiki_home.js"), 
					dir: "pubgm_mainsite/wiki_home/wiki_home"
			   },
			   wiki_list: {
				html: require("../../pubgm_mainsite/wiki_list/wiki_list.html.twig"), 
				scss: require("../../pubgm_mainsite/wiki_list/wiki_list.scss"), 
				js: require("../../pubgm_mainsite/wiki_list/wiki_list.js"), 
				dir: "pubgm_mainsite/wiki_list/wiki_list"
		   },
			   esports: {
				html: require("../../pubgm_mainsite/esports/esports.html.twig"), 
				scss: require("../../pubgm_mainsite/esports/esports.scss"), 
				js: require("../../pubgm_mainsite/esports/esports.js"), 
				dir: "pubgm_mainsite/esports/esports"
		   },
			},
			footer:{
				footer: {
					 html: require("../../pubgm_mainsite/footer/footer.html.twig"), 
					 scss: require("../../pubgm_mainsite/footer/footer.scss"), 
					 js: require("../../pubgm_mainsite/footer/footer.js"), 
					 dir: "pubgm_mainsite/footer/footer"
				}
			},
			float:{
				float_right: {
					 html: require("../../pubgm_mainsite/float_right/float_right.html.twig"), 
					 scss: require("../../pubgm_mainsite/float_right/float_right.scss"), 
					 js: require("../../pubgm_mainsite/float_right/float_right.js"), 
					 dir: "pubgm_mainsite/float_right/float_right"
				},
				float_top: {
					 html: require("../../pubgm_mainsite/float_top/float_top.html.twig"), 
					 scss: require("../../pubgm_mainsite/float_top/float_top.scss"), 
					 js: require("../../pubgm_mainsite/float_top/float_top.js"), 
					 dir: "pubgm_mainsite/float_top/float_top"
				}
			}
		},
		common: {
			required:{
				required_loading: {
					 html: require("../../common/required_loading/required_loading.html.twig"), 
					 scss: require("../../common/required_loading/required_loading.scss"), 
					 js: require("../../common/required_loading/required_loading.js"), 
					 dir: "common/required_loading/required_loading"
				}
			}
		}
    }
} catch(error) {
    console.log(error);
}

export default blockBundles;